export default __webpack_public_path__ + "static/media/download-icon.c4827b17.svg";